import { defineComponent as c, inject as y, ref as k, watch as x, computed as p, withDirectives as g, openBlock as C, createElementBlock as I, normalizeClass as V, vModelText as v } from "vue";
import { PinInputSymbol as D, getPinInputStyleClasses as P } from "./novoui-vuejs79.js";
const N = /* @__PURE__ */ c({
  __name: "NPinSlot",
  props: {
    keyindex: { default: 0 },
    focusedIndex: { default: -1 },
    modelValue: { default: "" }
  },
  emits: ["update:singleDigit", "update:modelValue", "paste"],
  setup(d, { emit: m }) {
    const t = d, o = y(D, {}), n = k();
    x(
      () => t.focusedIndex,
      (e) => {
        e === t.keyindex && n.value.focus();
      }
    );
    const u = m;
    function s() {
      n.value.select();
    }
    const r = p(() => P(o)), a = p({
      get: () => t.modelValue,
      set: (e) => {
        u("update:modelValue", e), u("update:singleDigit", t.keyindex, e), t.keyindex + 1 === o.pinInputCount && n.value.blur();
      }
    }), f = (e) => {
      e.key.length === 1 && (isNaN(Number(e.key)) || e.key === " ") && e.preventDefault();
    };
    return (e, i) => g((C(), I("input", {
      "onUpdate:modelValue": i[0] || (i[0] = (l) => a.value = l),
      ref_key: "pinRef",
      ref: n,
      class: V([r.value, "pin-input"]),
      onClick: s,
      onFocusin: s,
      onKeydown: f,
      onPaste: i[1] || (i[1] = (l) => e.$emit("paste", l)),
      type: "text",
      inputmode: "numeric",
      "aria-label": "pin input field",
      maxlength: "1"
    }, null, 34)), [
      [v, a.value]
    ]);
  }
});
export {
  N as default
};
